import { useAuthStore } from '@/stores/auth.ts';
import * as Amplitude from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { featureFlagService } from '@/models/feature-flag';
export class AmplitudeService {
    initAmplitude() {
        var _a, _b, _c, _d;
        if (!this.canUseAmplitude()) {
            return;
        }
        const anonymousDeviceId = localStorage.getItem('amp_annon_id');
        Amplitude.init(process.env.AMPLITUDE_API_KEY, (_b = (_a = this.getAuthStore().user) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.id, {
            deviceId: anonymousDeviceId || undefined,
            serverZone: 'EU',
            autocapture: {
                attribution: true,
                pageViews: false,
                sessions: true,
                formInteractions: false,
                fileDownloads: false,
                elementInteractions: false,
            },
        });
        if (anonymousDeviceId) {
            localStorage.removeItem('amp_annon_id');
        }
        Amplitude.setUserId((_d = (_c = this.getAuthStore().user) === null || _c === void 0 ? void 0 : _c.profile) === null || _d === void 0 ? void 0 : _d.id);
    }
    initAnonymousAmplitude(deviceId = null) {
        if (!process.env.AMPLITUDE_API_KEY) {
            return;
        }
        if (!deviceId) {
            return;
        }
        Amplitude.init(process.env.AMPLITUDE_API_KEY, undefined, {
            deviceId: deviceId,
            serverZone: 'EU',
            autocapture: {
                attribution: true,
                pageViews: false,
                sessions: false,
                formInteractions: false,
                fileDownloads: false,
                elementInteractions: false,
            },
        });
        localStorage.setItem('amp_annon_id', deviceId || '');
    }
    resetAmplitude() {
        Amplitude.flush();
        Amplitude.reset();
    }
    trackEvent(eventName, eventProperties = {}) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (!this.canUseAmplitude()) {
            return;
        }
        // push user subscription status to event properties object
        if (eventProperties) {
            eventProperties.trial_user = (_c = (_b = (_a = this.getAuthStore().user) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.user_subscription) === null || _c === void 0 ? void 0 : _c.is_trial_user;
            eventProperties.user_subscription = (_f = (_e = (_d = this.getAuthStore().user) === null || _d === void 0 ? void 0 : _d.permissions) === null || _e === void 0 ? void 0 : _e.user_subscription) === null || _f === void 0 ? void 0 : _f.tag;
        }
        else {
            eventProperties = {
                trial_user: (_j = (_h = (_g = this.getAuthStore().user) === null || _g === void 0 ? void 0 : _g.permissions) === null || _h === void 0 ? void 0 : _h.user_subscription) === null || _j === void 0 ? void 0 : _j.is_trial_user,
                user_subscription: (_m = (_l = (_k = this.getAuthStore().user) === null || _k === void 0 ? void 0 : _k.permissions) === null || _l === void 0 ? void 0 : _l.user_subscription) === null || _m === void 0 ? void 0 : _m.tag,
            };
        }
        if (this.getAuthStore().locale) {
            const identifyEvent = new Amplitude.Identify();
            const locale = this.getAuthStore().locale;
            identifyEvent.set('app_language', locale !== null && locale !== void 0 ? locale : 'language_not_set');
        }
        Amplitude.track(eventName, eventProperties);
    }
    getAuthStore() {
        return useAuthStore();
    }
    canUseAmplitude() {
        var _a, _b;
        if (!process.env.AMPLITUDE_API_KEY) {
            return false;
        }
        if (!((_b = (_a = this.getAuthStore().user) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.id)) {
            return false;
        }
        if (!featureFlagService.can('amplitude-kill-switch')) {
            return false;
        }
        return true;
    }
    initEngagementPlugin(lang) {
        Amplitude.add(engagementPlugin({
            serverZone: 'EU',
            locale: lang || 'lt',
        }));
    }
    initSessionReplayPlugin() {
        Amplitude.add(sessionReplayPlugin());
    }
}
export const amplitudeService = new AmplitudeService();
